import { useQuery } from '@tanstack/react-query'
import { XIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { useResizeWindow } from '@/lib/hooks/use-resize-window'
import { taskActionHistoryQuery } from '@/lib/queries/business/v1/task/action/history/queries'
import { cn } from '@/lib/utils'

import { LoadingSkeleton } from './loading-skeleton'
import { RecentActivityList } from './recent-activity-list/recent-activity-list'

export interface CaseRecentActivityDrawerProps {
  open: boolean
  taskId: number
  onClickCloseButton: VoidFunction
}

export const CaseRecentActivityDrawer = ({ open, taskId, onClickCloseButton }: CaseRecentActivityDrawerProps) => {
  const { data: taskActionHistoryData, isFetching: isFetchingTaskActionHistoryData } = useQuery(
    taskActionHistoryQuery(taskId)
  )

  const { height: windowHeight } = useResizeWindow()
  const topNavBarOffset = parseInt(window.getComputedStyle(document.body).getPropertyValue('--top-nav-bar-offset'), 10)

  if (!open) {
    return null
  }

  return (
    <div
      className={cn(
        'fixed bottom-0 right-0',
        'flex flex-col',
        'min-w-[400px]',
        'h-full',
        'bg-white',
        'border-l border-l-border',
        'shadow-[0px_4px_6px_0px_rgba(0,0,0,0.09)]'
      )}
      style={{
        height: `${windowHeight - topNavBarOffset}px`,
      }}
    >
      <div className={cn('flex items-center justify-between', 'px-[20px] py-[30px]')}>
        <p className={cn('text-2xl font-semibold text-foreground')}>Recent Activities</p>
        <Button type="button" variant="ghost" size="icon" onClick={onClickCloseButton}>
          <XIcon size={24} />
        </Button>
      </div>

      <div className={cn('flex-1', 'px-[30px] pb-[40px] pt-[20px]', 'overflow-y-auto')}>
        {isFetchingTaskActionHistoryData && <LoadingSkeleton />}
        {!isFetchingTaskActionHistoryData && <RecentActivityList data={taskActionHistoryData} />}
      </div>
    </div>
  )
}
